import type { PropertyInterface } from './PropertyInterface'

export abstract class AbstractBoolProperty implements PropertyInterface {
  abstract KEY: string

  constructor(private readonly value: boolean) {}

  getKey(): string {
    return this.KEY
  }

  getValue(): boolean {
    return this.value
  }
}
